import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { ToastContainer, toast } from "react-toastify";
import "sweetalert2/src/sweetalert2.scss";
import Lightbox from "react-image-lightbox";
import moment from "moment";


//import filter modal
import {
  getRequest,
  postRequest,
  deleteRequest,
  putRequest,
  postRequestForm,
  deleteConfirmationWords,
} from "components/Common/Utils";

import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";
import axios from "axios";

import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Spinner,
  Badge,
  UncontrolledTooltip,
  Modal,
  Button,
} from "reactstrap";
import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import ReactPaginate from "react-paginate";
import { change } from "redux-form";
import { id } from "date-fns/locale";
// import BuyProduct from "components/Modal/BuyProduct";

const filterObj = {
  first_name: "",
  last_name: "",
  gender: "",
  email: "",
  phone: "",
  country: "",
  nationality: "",
  bookingCode: "",
  bookingDate: "",
  agentEmail: "",
};

const StockAlretTable = (props) => {

  console.log("props", props);
  const [modal_center, setmodal_center] = useState(false);
  const [Categorydata, setCategorydata] = useState([]);
  const [loader, setLoader] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [value, setValue] = React.useState(10);
  const [sort, setsort] = React.useState("");
  const [sortOrder, setsortOrder] = React.useState("desc");
  const [currentFPage, setCurrentFPage] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(0);
  const [sizePerPageOrg, setSizePerPage] = useState(5);
  const [image, setImage] = React.useState("");
  const [openLightbox, setOpenLightBox] = React.useState(false);
  const [sizeList, setSizeList] = useState([]);
  const [model, setModel] = useState(false);
  const [buyProductdata, setBuyProductdata] = useState({});
const [cart, setCart] = useState([]);
const [manufactuereId, setManufactuereId] = useState(null);
const [addedToCart, setAddedToCart] = useState(new Set());
const [cartQuantities, setCartQuantities] = useState(new Map());

const [totalCartAmount, setTotalCartAmount] = useState(0);



  const handleReset = () => {
    setSearchText('');
    fetchStockAlret();
  };

  useEffect(() => {
    if (searchText === '') {
      fetchStockAlret();
    }
  }, [searchText]);
  

  useEffect(() => {
    fetchStockAlret();
  }, [currentPage]);

  useEffect(() => {
    fetchStockAlret();
  }, [sort, sortOrder]);

const getCartItem = (productId) => {
  return cart.find((item) => item._id === productId);
};
const getPriceForQuantity = (row, quantity) => {
  const ranges = row?.productDetail?.priceRange || [];

  if (!ranges.length) return 0;

  const found = ranges.find(
    (r) => quantity >= r.minQuantity && quantity <= r.maxQuantity
  );

  if (found) return found.price;

  // if quantity exceeds all ranges
  return ranges[ranges.length - 1]?.price || 0;
};


const addToCart = (row) => {
  const minQty = row?.productDetail?.priceRange?.[0]?.minQuantity || 1;
  const currentManufacturer = row?.productDetail?.manufactureId;

  if (!row?.warehouseId) {
    Swal.fire("Warehouse not found for this product");
    return;
  }

  if (getCartItem(row?.productDetail?._id)) return;

  // ✅ BLOCK MULTIPLE MANUFACTURERS HERE
  if (cart.length > 0 && cart[0].manufactureId !== currentManufacturer) {
    Swal.fire({
      icon: "warning",
      title: "Different Manufacturer",
      text: "You can only add products from one manufacturer at a time. Clear cart to add this product.",
      confirmButtonText: "OK"
    });
    return;
  }

  const item = {
    _id: row?.productDetail?._id,
    name: row?.productDetail?.name,
    image: row?.productDetail?.images?.[0],
    price: getPriceForQuantity(row, minQty),
    quantity: minQty,
    minimumQuantity: minQty,

    // ✅ KEEP THIS NAME EXACT
    manufactureId: row?.productDetail?.manufactureId,

    warehouseId: row?.warehouseId
  };

  setCart((prev) => [...prev, item]);

  // ✅ SET MANUFACTURER IMMEDIATELY
  if (!manufactuereId) {
    setManufactuereId(currentManufacturer);
  }
};




const increaseQty = (id, row) => {
  setCart((prev) =>
    prev.map((item) =>
      item._id === id
        ? {
            ...item,
            quantity: item.quantity + 1,
            price: getPriceForQuantity(row, item.quantity + 1),
          }
        : item
    )
  );
};


const decreaseQty = (id, row) => {
  setCart((prev) =>
    prev.map((item) => {
      if (item._id !== id) return item;

      const newQty =
        item.quantity > item.minimumQuantity
          ? item.quantity - 1
          : item.quantity;

      return {
        ...item,
        quantity: newQty,
        price: getPriceForQuantity(row, newQty),
      };
    })
  );
};


const removeFromCart = (id) => {
  setCart((prev) => prev.filter((item) => item._id !== id));
};

const totalItems = cart.reduce((acc, item) => acc + item.quantity, 0);
const totalAmount = cart.reduce((acc, item) => acc + (item.quantity * item.price), 0);
const cartTotalItem = cart.map((item) => ({
  productId: item._id,
  quantity: item.quantity,
  price: item.price,
  totalPrice: item.price * item.quantity
}));

const proceedToCheckout = async () => {
  if (cart.length === 0) {
    return Swal.fire("Cart is empty!");
  }

  const _id = cart[0]?.manufactureId;

  if (!(_id)) {
    return Swal.fire("Manufacturer not found");
  }

  if (manufactuereId && manufactuereId !== _id) {
    Swal.fire({
      icon: "warning",
      title: "Cart Conflict",
      text: "Cart already belongs to another manufacturer. If you proceed, the previous cart will be cleared, and this manufacturer's products will be added.",
      showCancelButton: true,
      confirmButtonText: "OK",
      cancelButtonText: "Cancel"
    }).then(async (result) => {
      if (result.isConfirmed) {
        const res = await postRequest("/order/admin/add-to-cart", {
          manufactureId: _id,
          products: cartTotalItem
        });

        if (res.status) {
          setManufactuereId(_id);

          Swal.fire({
            icon: "success",
            title: "Products Added!",
            text: "Products added to cart successfully!",
            confirmButtonText: "OK"
          }).then((result) => {
            if (result.isConfirmed) {
              setCart([]);
              props.history.push("/cart");
            }
          });
        } else {
          toast.error("Something went wrong");
          setLoader(false);
        }
      }
    });

    return;
  }

  // Same manufacturer OR first order
  const res = await postRequest("/order/admin/add-to-cart", {
    manufactureId: _id,
    products: cartTotalItem
  });

  if (res.status) {
    setManufactuereId(_id);

    Swal.fire({
      icon: "success",
      title: "Products Added!",
      text: "Products added to cart successfully!",
      confirmButtonText: "OK",
      allowOutsideClick: false
    }).then((result) => {
      if (result.isConfirmed) {
        setCart([]);
        props.history.push("/cart");
      }
    });
  } else {
    toast.error("Something went wrong");
    setLoader(false);
  }
};

  const handleTableChange = (type, { page, sizePerPage, searchText }) => {
    if (type === "pagination") {
      if (page != currentPage) {
        setCurrentPage(page);
        console.log("page", page);
      }
    }
    if (type === "search") {
      console.log("searchText", searchText);
    }
  };

 
  const showLightBox = (image) => {
    setImage(image);
    setOpenLightBox(true);
  };

  const handleDownload = () => {
    const downloadLink = document.createElement("a");
    downloadLink.href = image;
    downloadLink.download = "downloaded-image.jpg";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  function SNoFormatter(cellContent, row, i) {
    return <>{i + 1}</>;
  }

  function ManufacturerFormatter(cellContent, row) {
    return (
      <div className="d-flex gap-2 align-items-start">
        <Link to={`/manufacturers-details/${row?.manufacturerDetail?._id}`}>
          <div style={{ width: '40px' }}><img src={row?.manufacturerDetail?.logo} width="40px" /></div>
        </Link>
        <div className="flex-product text-start">
          <Link to={`/manufacturers-details/${row?.manufacturerDetail?._id}`} className="mb-0">{row?.manufacturerDetail?.companyName}</Link>
          {/* <p className="mb-0">{row?.manufacturerDetail?.mobile}, </p> */}
          <p className="mb-0">{row?.manufacturerDetail?.address}</p>
        </div>
      </div>
    );
  }

  function ProductFormatter(cellContent, row) {
    return (
      <>
        <img
          src={row?.productDetail?.images?.[0]}
          onClick={() => showLightBox(row?.productDetail?.images?.[0])}
          alt="Not found Image"
          width={"40px"}
        />
      </>
    );
  }

  
  const selectRow = (item) => {
    setModel(false);
  };

 
 const columns = [
  {
    text: "S.NO",
    formatter: SNoFormatter,
    sort: false,
  },

  {
    dataField: "images[]",
    text: "Product image",
    sort: false,
    formatter: ProductFormatter,
  },

  {
    dataField: "productDetail.name",
    text: "Product Name",
    sort: false,
  },
  {
    text: "Manufacturer Info",
    sort: false,
    formatter: ManufacturerFormatter,
  },
  {
    dataField: "quantity",
    text: "Quantity",
    sort: false,
  },
  {
    dataField: "remainingQuantity",
    text: "Remaining Quantity",
    sort: false,
  },
  {
    dataField: "stockAlert",
    text: "Stock Alert Quantity",
    sort: false,
  },

 {
  dataField: "_id",
  text: "Actions",
  formatter: addToCartFormatter,   // <- changed
  formatExtraData: cart,           // <- keep
  sort: false,
},
];


  const handleChange = (event) => {
    setSizePerPage(event.target.value);
    if (currentPage != 1) {
      setCurrentPage(1);
    } else {
      fetchStockAlret(null, event.target.value);
    }
  };
  const handlesorting = (event) => {
    setsort(event.target.value);
  };
  const handlesortOrder = (event) => {
    setsortOrder(event.target.value);
  };


 function addToCartFormatter(cellContent, row, rowIndex, extraData) {
  const cartItem = extraData.find(
    (item) => item._id === row?.productDetail?._id
  );

  const quantity = cartItem?.quantity || 0;
  const minimumQuantity =
    cartItem?.minimumQuantity ||
    row?.productDetail?.priceRange?.[0]?.minQuantity ||
    1;

  return (
    <div className="d-flex product-add justify-content-center" style={{ width: "190px" }}>
      {row?.productDetail?.isPublished !== false ? (
        <>
          {cartItem ? (
            <div>
              <div className="cart_qty mb-2 animate__animated animate__slideInRight">
                <div className="input-group quantity-prod">

                  <button
                    type="button"
                    className="btn qty-left-minus"
                 onClick={() => decreaseQty(cartItem._id, row)}

                    disabled={quantity <= minimumQuantity}
                  >
                    <i className="fa fa-minus ms-0" />
                  </button>

                  <input
                    className="form-control input-number qty-input"
                    type="number"
                    value={quantity}
                    onChange={(e) => {
                      let val = Number(e.target.value);
                      if (val < minimumQuantity) val = minimumQuantity;

                     setCart((prev) =>
  prev.map((item) =>
    item._id === cartItem._id
      ? {
          ...item,
          quantity: val,
          price: getPriceForQuantity(row, val),
        }
      : item
  )
);

                    }}
                  />

                  <button
                    type="button"
                    className="btn qty-right-plus"
                    onClick={() => increaseQty(cartItem._id, row)}
                  >
                    <i className="fa fa-plus ms-0" />
                  </button>

                </div>
              </div>

              <p className="mb-0 remove-cart" onClick={() => removeFromCart(cartItem._id)}>
                Remove
              </p>
            </div>
          ) : (
            <button
              type="button"
              className="btn btn-info mx-2"
              onClick={() => addToCart(row)}
            >
              <i className="fal fa-shopping-cart"></i> Add To Cart
            </button>
          )}
        </>
      ) : (
        <button
          className="btn btn-secondary disabled mx-2"
          type="button"
        >
          <i className="fal fa-shopping-cart"></i> Add To Cart
        </button>
      )}
    </div>
  );
}



  const limit = 10;
  const fetchStockAlret = async (limit = null) => {
    console.log(currentPage);
    setLoader(true);
    const payload = {
      limit: limit ? limit : sizePerPageOrg,
      page: currentPage,
      search: searchText,
      sortOrder: sortOrder,
    };
    try {
      const response = await postRequest(`analytics/stock-Alert`, payload);
      const data = response.data;
      setTotalPage(data?.count);
      setCurrentFPage(data?.page);
      setCategorydata(data?.list || []);
    } catch (error) {
      console.log("Failed to fetch data:", error);
    } finally {
      setLoader(false);
    }
  };


  const toggleModel = (row) => {
    console.log("toggleModel", model);
    setModel(!model);
    const dataFilter = {
      name : row?.productDetail?.name,
      images : row?.productDetail?.images,
      _id : row?.productDetail?._id,
      minimumQuantity : row?.productDetail?.priceRange?.[0]?.minQuantity,
      manufacturerDetail : row?.manufacturerDetail,
    }
    setBuyProductdata(dataFilter);
  };

  const closeModal = () => {
    setModel(false);
  };

  return (
    <>
      <React.Fragment>
        <ToastContainer />
        <Row>

          <Col className="col-12">
     

            {loader ? (
              <CardBody style={{ height: "100px" }}>
                <Spinner
                  color="info"
                  style={{
                    height: "4rem",
                    width: "4rem",
                    position: "absolute",
                    left: "50%",
                  }}
                >
                  Loading...
                </Spinner>
              </CardBody>
            ) : (
              <div className="">
                {
                  <PaginationProvider
                    pagination={paginationFactory({
                      page: currentFPage,
                      sizePerPage: sizePerPageOrg,
                      totalSize: totalPage,
                      custom: true,
                    })}
                  >
                    {({ paginationProps, paginationTableProps }) => (
                      <>
                        <ToolkitProvider
                          keyField="_id"
                          data={Categorydata}
                          columns={columns}
                        >
                          {(props) => (
                            <Row>
                              <Col className="col-lg-12 d-flex mb-3">
                                <label className="mb-0 text-label">
                                  Page Size
                                </label>

                                <select
                                  value={sizePerPageOrg}
                                  onChange={handleChange}
                                  className="form-select"
                                  style={{ width: "7%" }}
                                >
                                  <option value="10">10</option>

                                  <option value="20">20</option>

                                  <option value="50">50</option>
                                </select>

                                {/* <label className="mb-0 text-label ms-3">
                                    Sort By:
                                  </label>
                                  <select
                                    value={sort}
                                    onChange={handlesorting}
                                    className="form-select"
                                    style={{ width: "10%" }}
                                  >
                                    <option value="title">Title Name</option>

                                    <option value="description">
                                      Description
                                    </option>
                                  </select> */}
                                <label className="mb-0 text-label ms-3">
                                  Sort Order:
                                </label>
                                <select
                                  value={sortOrder}
                                  onChange={handlesortOrder}
                                  className="form-select"
                                  style={{ width: "10%" }}
                                >
                                  <option value="asc"> Ascending</option>
                                  <option value="desc">Descending</option>
                                </select>
                                <div className="filter-item" style={{ width: '86.5%' }}>
                                  <input
                                    type="search"
                                    placeholder="Search"
                                    value={searchText}
                                    class="form-control"
                                    onChange={(e) =>
                                      setSearchText(e.target.value)
                                    }
                                    style={{ width: "30%" }}
                                  />
                                  <button
                                    onClick={() => {
                                      fetchStockAlret();
                                    }}
                                    type="button"
                                    className="btn btn-primary mx-2"
                                  >
                                    Search
                                  </button>

                                  <button
                                    type="button"
                                    onClick={handleReset}
                                    className="btn btn-danger mx-2"
                                  >
                                    Reset
                                  </button>
                                  {/* <button
                                      type="button"
                                      onClick={toggleModel}
                                      className="btn btn-info"
                                    >
                                      Filter
                                    </button> */}
                                </div>
                              </Col>
                                  {cart.length > 0 && (
  <Col  className="card-box-cart ">
    <div>
      <h5>
        Total Items :
        <span> {totalItems}</span>
      </h5>
      <h5>
        Total Amount :
        <span> ${totalAmount}</span>
      </h5>
    </div>

    <button
      type="button"
      onClick={proceedToCheckout}
      className="btn place-btn btn-info"
    >
      Proceed to Checkout
    </button>
  </Col>
)}

                              <Col className="col-lg-12 text-end col-set">
                                <BootstrapTable
                                  onTableChange={handleTableChange}
                                  remote={true}
                                  classes="table-striped"
                                  {...props.baseProps}
                                  {...paginationTableProps}
                                />
                              </Col>
                            </Row>
                          )}
                        </ToolkitProvider>

                        <Row>
                          <Col className="col-lg-12 text-end">
                            <div className="text-md-right">
                              <PaginationListStandalone
                                {...paginationProps}
                              />
                            </div>
                          </Col>
                        </Row>
                      </>
                    )}
                  </PaginationProvider>
                }
              </div>
            )}
          </Col>
        </Row>
        {openLightbox && (
          <>
            <Lightbox
              mainSrc={image}
              onCloseRequest={() => setOpenLightBox(false)}
              toolbarButtons={[
                <button
                  className="btn btn-primary"
                  key="download"
                  onClick={handleDownload}
                >
                  Download
                </button>,
              ]}
            />
          </>
        )}
      </React.Fragment>
      {/* <BuyProduct
          show={model}
          data={buyProductdata}
          closeModal={closeModal}
          selectRow={selectRow} /> */}
    </>
  );
};

export default StockAlretTable;
